/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-16",
    versionChannel: "nightly",
    buildDate: "2025-04-16T00:06:46.833Z",
    commitHash: "e01842f964831ae4bc13f1cf0604f0fa9921a834",
};
